import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { 
  PressRollComponent, 
  Ef3IntegratesLinescapeDataComponent, 
  DbhIntegratesLinescapeComponent, 
  Linescape4AniversaryTranshipmentVoyageComponent, 
  XenetaAddsLinescapeComponent, 
  HavenOceanFreightMarketplaceLinescapeComponent, 
  TechStackAnniversaryComponent, 
  LinescapeUpgradesSearchEngineComponent, 
  LinescapeExhibitIntermodalEuropeComponent, 
  LinescapeMoreDataAnniversaryComponent, 
  DakosyToDistributeLinescapeComponent, 
  LinescapeCIAwardFinalistComponent, 
  DachserSelectsLinescapeSchedulesComponent, 
  LinescapeVesselInformationAnniversaryComponent, 
  LinescapeExhibitIntermodalEuropeAmsterdamComponent, 
  TransworldExpeditionShipTruckComponent, 
  LinescapeCarrierProfilesAnniversaryComponent, 
  LinescapeLaunchesOceanContainerSearchComponent, 
  LinescapeLaunchesSailingScheduleComponent, 
  CogoportAddsLinescapeSchedulesComponent, 
  LinescapeCelebrates10thAnniversaryComponent, 
  LinescapeWebsiteNewLookComponent, 
  SuzhouYunLogisticsTechnologySelectsLinescape, 
  LinescapeJournalOfCommerceComponent, 
  LinescapeCeoToSpeakAtGlobalLinerShippingConference,
  LinescapeEnhancesSailingScheduleswithActualTrackingData, 
  LogitOneChoosesLinescapeAsSaillingScheduleProvider,
  KotachiSelectsLinescapeSailingSchedulesApi,
  JfHillebrandToIntegrateLinescapeIntoTms,
  MercurygateAddsLinescapeToTme,
} from './';

import { AppContext, SeoService } from './../shared';
import { SharedModule } from '../shared/shared.module';
import { PressRoutingModule } from './press-routing.module';

@NgModule({
  imports: [ CommonModule, PressRoutingModule, SharedModule ],
  declarations: [ 
    Ef3IntegratesLinescapeDataComponent, 
    DbhIntegratesLinescapeComponent, 
    Linescape4AniversaryTranshipmentVoyageComponent, 
    XenetaAddsLinescapeComponent, 
    HavenOceanFreightMarketplaceLinescapeComponent, 
    TechStackAnniversaryComponent, 
    LinescapeUpgradesSearchEngineComponent, 
    LinescapeExhibitIntermodalEuropeComponent, 
    LinescapeMoreDataAnniversaryComponent, 
    DakosyToDistributeLinescapeComponent, 
    LinescapeCIAwardFinalistComponent, 
    DachserSelectsLinescapeSchedulesComponent, 
    LinescapeVesselInformationAnniversaryComponent, 
    LinescapeExhibitIntermodalEuropeAmsterdamComponent, 
    TransworldExpeditionShipTruckComponent, 
    LinescapeCarrierProfilesAnniversaryComponent, 
    LinescapeLaunchesOceanContainerSearchComponent, 
    LinescapeLaunchesSailingScheduleComponent, 
    CogoportAddsLinescapeSchedulesComponent, 
    LinescapeCelebrates10thAnniversaryComponent, 
    LinescapeWebsiteNewLookComponent, 
    SuzhouYunLogisticsTechnologySelectsLinescape, 
    LinescapeJournalOfCommerceComponent, 
    LinescapeCeoToSpeakAtGlobalLinerShippingConference, 
    LinescapeEnhancesSailingScheduleswithActualTrackingData,
    LogitOneChoosesLinescapeAsSaillingScheduleProvider,
    KotachiSelectsLinescapeSailingSchedulesApi, 
    JfHillebrandToIntegrateLinescapeIntoTms,
    MercurygateAddsLinescapeToTme,
    PressRollComponent ],
  exports: [ 
    Ef3IntegratesLinescapeDataComponent, 
    DbhIntegratesLinescapeComponent, 
    Linescape4AniversaryTranshipmentVoyageComponent, 
    XenetaAddsLinescapeComponent, 
    HavenOceanFreightMarketplaceLinescapeComponent, 
    TechStackAnniversaryComponent, 
    LinescapeUpgradesSearchEngineComponent, 
    LinescapeExhibitIntermodalEuropeComponent, 
    LinescapeMoreDataAnniversaryComponent, 
    DakosyToDistributeLinescapeComponent, 
    LinescapeCIAwardFinalistComponent, 
    DachserSelectsLinescapeSchedulesComponent, 
    LinescapeVesselInformationAnniversaryComponent, 
    LinescapeExhibitIntermodalEuropeAmsterdamComponent, 
    TransworldExpeditionShipTruckComponent, 
    LinescapeCarrierProfilesAnniversaryComponent, 
    LinescapeLaunchesOceanContainerSearchComponent, 
    LinescapeLaunchesSailingScheduleComponent, 
    CogoportAddsLinescapeSchedulesComponent, 
    LinescapeCelebrates10thAnniversaryComponent, 
    LinescapeWebsiteNewLookComponent, 
    SuzhouYunLogisticsTechnologySelectsLinescape, 
    LinescapeJournalOfCommerceComponent, 
    LinescapeCeoToSpeakAtGlobalLinerShippingConference,
    LinescapeEnhancesSailingScheduleswithActualTrackingData, 
    LogitOneChoosesLinescapeAsSaillingScheduleProvider,
    KotachiSelectsLinescapeSailingSchedulesApi,
    JfHillebrandToIntegrateLinescapeIntoTms,
    MercurygateAddsLinescapeToTme,
    PressRollComponent ],
  providers: [ AppContext, SeoService ]
})

export class PressModule {}


// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/press/press.module.ts